import { defineComponent as n, openBlock as o, createBlock as r, unref as p, mergeProps as d, withCtx as m, createElementVNode as e } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconSunBeam",
  __name: "IconSunBeam",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const t = l;
    return (i, a) => (o(), r(p(c), d(t, { "view-box": "0 0 48 48" }), {
      default: m(() => [...a[0] || (a[0] = [
        e("g", { "clip-path": "url(#7894eee8-8b86-4956-b80d-9a3863dbf278a)" }, [
          e("path", { d: "M24 2.398 28.633 6.7l6.17-1.39 1.85 5.993 6.001 1.87-1.416 6.15 4.369 4.65-4.31 4.627 1.393 6.161-6.002 1.846-1.873 5.994-6.158-1.415L24 45.55l-4.633-4.303-6.17 1.39-1.85-5.993-6.085-1.882 1.416-6.149-4.285-4.639 4.31-4.627-1.393-6.161 6.002-1.846 1.873-5.994 6.158 1.415L24 2.398M24 0a2.4 2.4 0 0 0-1.62.636l-3.722 3.428-4.921-1.139a3 3 0 0 0-.54-.06 2.4 2.4 0 0 0-2.257 1.69L9.44 9.35l-4.802 1.486a2.4 2.4 0 0 0-1.633 2.817l1.117 4.927-3.482 3.716a2.396 2.396 0 0 0 0 3.26l3.434 3.716-1.14 4.915a2.394 2.394 0 0 0 1.62 2.829l4.801 1.498 1.489 4.795a2.396 2.396 0 0 0 2.353 1.726 2 2 0 0 0 .528 0l4.933-1.115 3.697 3.44a2.4 2.4 0 0 0 3.266 0l3.72-3.428 4.922 1.199a3 3 0 0 0 .54 0 2.4 2.4 0 0 0 2.293-1.69l1.5-4.795 4.802-1.486a2.4 2.4 0 0 0 1.633-2.817l-1.117-4.927 3.446-3.692a2.395 2.395 0 0 0 0-3.26l-3.434-3.716 1.2-4.915a2.394 2.394 0 0 0-1.632-2.829l-4.801-1.498-1.489-4.795a2.4 2.4 0 0 0-2.4-1.798 2 2 0 0 0-.529.06l-4.933 1.115-3.662-3.44A2.4 2.4 0 0 0 24 0" })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "7894eee8-8b86-4956-b80d-9a3863dbf278a" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
